// Адреса юридических документов. Это НЕ маршруты приложения (routes.ts): страницы статические,
// лежат в `apps/web/public/`, отдаются nginx мимо SPA-фолбэка и открываются во внешнем браузере.
import { PRIVACY_PATH, TERMS_PATH, TERMS_VERSION, termsVersionPath } from '@lunya/contracts'

/**
 * Запасной origin на случай, когда `window` недоступен (тесты, любой не-браузерный прогон).
 * Совпадает с доменом из Caddyfile.
 */
const FALLBACK_ORIGIN = 'https://lunya-ryadom.app'

/**
 * Адрес собирается от текущего origin, а не вшивается целиком: документы выкатываются тем же
 * деплоем и тем же контейнером, что и сама мини-аппа, поэтому они всегда лежат рядом. Вшитый
 * домен разъехался бы с реальностью в первый же день, когда домен сменится, — а мёртвая ссылка
 * на юридически значимом экране хуже её отсутствия.
 */
const documentUrl = (path: string): string =>
  typeof window === 'undefined' ? `${FALLBACK_ORIGIN}${path}` : `${window.location.origin}${path}`

/** Политика обработки персональных данных. */
export const PRIVACY_POLICY_URL: string = documentUrl(PRIVACY_PATH)

/**
 * Пользовательское соглашение (публичная оферта), действующая редакция.
 *
 * `/terms` всегда указывает на действующую редакцию, а сама редакция лежит по адресу со своим
 * номером (`/terms/v1`). Номер приходит из контрактов — из той же константы, которой сервер
 * помечает запись об акцепте: страница, которую человеку показали, и текст, который записан
 * принятым, обязаны быть одним и тем же документом.
 */
export const TERMS_URL: string = documentUrl(TERMS_PATH)

/**
 * Постоянный адрес принятой человеком редакции. Нужен там, где мы показываем не «действующие
 * условия», а «те, которые вы приняли»: после выхода новой редакции это разные тексты.
 */
export const termsVersionUrl = (version: string = TERMS_VERSION): string =>
  documentUrl(termsVersionPath(version))
